import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Router} from '@angular/router';
import {ConsentsFormService} from '../../../services/consents-form.service';
import {MessageService} from '../../../services/message.service';
import {ToastMessagesService} from '../../../services/toast-messages.service';

@Component({
  selector: 'app-notification-message',
  templateUrl: './notification-message.component.html',
  styleUrls: ['./notification-message.component.scss']
})
export class NotificationMessageComponent implements OnInit {
  @Input() currentUser: any;
  @Input() message: any;
  @Output() closeMessage: EventEmitter<boolean> = new EventEmitter<boolean>();

  showMessage: boolean;
  messageWidth: any;
  constructor(public router: Router,
              public messageService: MessageService,
              public toastMessagesService: ToastMessagesService,
              public consentsFormService: ConsentsFormService) {
    this.showMessage = true;
    this.messageWidth = window.innerWidth - 15;
  }

  ngOnInit(): void {
  }

  getNotificationTitle(notification?: any) {
    return notification ? notification.formTitle : '';
  }

  async showConsent(notification: any) {
    // console.log(notification);
    // const child = this.children.find(c => c.id === notification.childId);
    //
    //  await this.consentsFormService.showConsent(notification, this.currentUser, child);
  }

  async displayMessage(id) {
      await this.messageService.displayMessage(id);
  }

  hideMessage() {
    this.closeMessage.emit(false);
  }
}
